import { IconType } from "react-icons";
import {
	FaYoutube,
	FaInstagram,
	FaFacebook,
	FaSoundcloud,
} from "react-icons/fa";
import { FaXTwitter, FaTiktok } from "react-icons/fa6";

export type SocialPlatformKey =
	| "youtube"
	| "instagram"
	| "tiktok"
	| "x"
	| "facebook"
	| "soundcloud";

export interface SocialPlatform {
	key: SocialPlatformKey;
	label: string;
	placeholder: string;
}

export const SOCIAL_PLATFORMS: SocialPlatform[] = [
	{
		key: "youtube",
		label: "YouTube",
		placeholder: "@example または https://www.youtube.com/@example",
	},
	{
		key: "instagram",
		label: "Instagram",
		placeholder: "example または https://www.instagram.com/example",
	},
	{
		key: "tiktok",
		label: "TikTok",
		placeholder: "@example または https://www.tiktok.com/@example",
	},
	{
		key: "x",
		label: "X (Twitter)",
		placeholder: "@example または https://x.com/example",
	},
	{
		key: "facebook",
		label: "Facebook",
		placeholder: "example または https://www.facebook.com/example",
	},
	{
		key: "soundcloud",
		label: "SoundCloud",
		placeholder: "example または https://soundcloud.com/example",
	},
];

export const SOCIAL_PLATFORM_MAP: Record<SocialPlatformKey, SocialPlatform> =
	SOCIAL_PLATFORMS.reduce(
		(acc, platform) => {
			acc[platform.key] = platform;
			return acc;
		},
		{} as Record<SocialPlatformKey, SocialPlatform>
	);

export const SOCIAL_PLATFORM_ICONS: Record<SocialPlatformKey, IconType> = {
	youtube: FaYoutube,
	instagram: FaInstagram,
	tiktok: FaTiktok,
	x: FaXTwitter,
	facebook: FaFacebook,
	soundcloud: FaSoundcloud,
};

export type SocialLinkState = Record<SocialPlatformKey, string>;

export const createEmptySocialLinkState = (): SocialLinkState =>
	SOCIAL_PLATFORMS.reduce(
		(acc, platform) => {
			acc[platform.key] = "";
			return acc;
		},
		{} as SocialLinkState
	);
